import { makeRPCPost } from '~api/RpcAPI/RpcAPI';

import { ICollection, IPGResponse } from '~api/CartAPI/ICartApiSdk';

interface ICollectionParams {
    COLLECTION_NAME?: string;
    COLLECTION_ID?: string;
}

export const addToCollection = (collectionName: string, skuBaseId: string | number) =>
    makeRPCPost([
        {
            method: 'rpc.form',
            params: [
                {
                    _SUBMIT: 'alter_collection',
                    action: 'add',
                    SKU_BASE_ID: skuBaseId,
                    COLLECTION_NAME: collectionName
                }
            ]
        }
    ]);

export const removeFromCollection = (collectionName: string, skuBaseId: string | number) =>
    makeRPCPost([
        {
            method: 'rpc.form',
            params: [
                {
                    _SUBMIT: 'alter_collection',
                    action: 'delete',
                    SKU_BASE_ID: skuBaseId,
                    collection_name: collectionName
                }
            ]
        }
    ]);

export const _getCollectionByName = (collectionName: string[]) =>
    makeRPCPost<ICollectionParams, IPGResponse<ICollection>>(
        collectionName.map((singleCollection) => ({
            method: 'collection.items',
            params: [{ COLLECTION_NAME: singleCollection }]
        }))
    );

export const _getCollectionById = (collectionIds: string[]) =>
    makeRPCPost<ICollectionParams, IPGResponse<ICollection>>(
        collectionIds.map((id) => ({
            method: 'collection.items',
            params: [{ COLLECTION_ID: id }]
        }))
    );
